import { Box } from "@mui/material"
import { StatusIndicator } from "../StatusIndicator"

type Props = {
  isLoading: boolean
  isError: boolean
}

export function Status({ isLoading, isError }: Props) {
  return (
    <Box sx={{ position: "absolute", top: -14, right: -14 }}>
      <StatusIndicator isLoading={isLoading} isError={isError} />
    </Box>
  )
}
